import { render, staticRenderFns } from "./LayoutProfile.vue?vue&type=template&id=36b88f56"
import script from "./LayoutProfile.vue?vue&type=script&lang=js"
export * from "./LayoutProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports